import { render, staticRenderFns } from "./comp_DiscountText.vue?vue&type=template&id=cd295156&"
import script from "./comp_DiscountText.vue?vue&type=script&lang=js&"
export * from "./comp_DiscountText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports